class ProductModel {
  id = null
  title = null
  cover = null
  brief = null
  publishDate = new Date()
  price = 0
  customerCourtesy = false
  subscriberCourtesy = false
  monetizationForFiliations = false
  digitalProduct = true
  productType = null
  productItems = []
  availableLanguages = ['pt', 'en', 'es']
  productInfos = [
    { title: '', language: 'pt', brief: '' },
    { title: '', language: 'en', brief: '' },
    { title: '', language: 'es', brief: '' },
  ]

  constructor(productType) {
    this.productType = productType
  }
}

export default productType => new ProductModel(productType)
